if (!customElements.get('read-more')) {
    customElements.define('read-more', class ReadMore extends HTMLElement {
        constructor(){
            super()
            this.buttons = this.querySelectorAll('.read-more__button')
            this.content = this.querySelector('.read-more__content')

            if(!this.buttons[0] || !this.content) return

            Array.from(this.buttons).forEach(button => {
                button.addEventListener('click', this._handleButtonClick.bind(this))
            })
        }

        _handleButtonClick(e){
            e.preventDefault()
            const clicked_button = e.target
            if(clicked_button.classList.contains('read-more__button--open')){
                this.classList.add('open')
            } else {
                this.classList.remove('open')
            }
            this.content.classList.toggle('read-more__content--open')
            
        }
    })
}